import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { useAppSelector } from '../../../stores/redux.store';

export type LoginTooManyAttemptsRecaptchaContextProps = {
  isRequired: boolean | undefined;
  captchaValue: string | null | undefined;
  setCaptchaValue: (_: string | null) => void;
};

export const LoginTooManyAttemptsRecaptchaContext =
  createContext<LoginTooManyAttemptsRecaptchaContextProps | null>(null);

export const LoginTooManyAttemptsRecaptchaContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [captchaValue, setCaptchaValue] = useState<string | null | undefined>(null);

  const tooManyFailedLogins = useAppSelector(state => state.login?.isCaptchaRequired);
  const recaptchaEnabled = useAppSelector(state => state.appConfig.recaptchaEnable);

  const isCaptchaRequired = tooManyFailedLogins && recaptchaEnabled;

  const value = useMemo(
    (): LoginTooManyAttemptsRecaptchaContextProps => ({
      isRequired: isCaptchaRequired,
      captchaValue,
      setCaptchaValue,
    }),
    [captchaValue, setCaptchaValue, isCaptchaRequired]
  );

  return (
    <LoginTooManyAttemptsRecaptchaContext.Provider value={value}>
      {children}
    </LoginTooManyAttemptsRecaptchaContext.Provider>
  );
};

export const useLoginTooManyAttemptsRecaptchaContext = () => {
  const context = useContext(LoginTooManyAttemptsRecaptchaContext);

  if (!context) {
    throw new Error(
      'useLoginTooManyAttemptsRecaptchaContext must be used within a LoginTooManyAttemptsRecaptchaContextProvider'
    );
  }

  return context;
};
